import { render, staticRenderFns } from "./HumanCapitalElderlyRateReport.vue?vue&type=template&id=5309f15b&scoped=true&"
import script from "./HumanCapitalElderlyRateReport.vue?vue&type=script&lang=js&"
export * from "./HumanCapitalElderlyRateReport.vue?vue&type=script&lang=js&"
import style0 from "./HumanCapitalElderlyRateReport.vue?vue&type=style&index=0&id=5309f15b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5309f15b",
  null
  
)

export default component.exports